export default function FourOneFourPage() {
  return (
    <div id="main">
      <div className="main-header">
        <h1>Page not found!</h1>
      </div>
    </div>
  );
}
